<app-checkout-page
  [addresses]="addresses$ | async"
  [order]="cartOrder$ | async"
  [checkoutPageSettings]="checkoutPageSettings$ | async"
  [quantityPicker]="quantityPicker$ | async"
  [minOrderValue]="customerMinOrderValue$ | async"
  [deliverydates]="deliverydates$ | async"
  [backordercounts]="backordercounts$ | async"
  [customerDiscounts]="customerDiscounts$ | async"
  [extraCosts]="extraCosts$ | async"
  (detailsChanged)="detailsChanged($event)"
  (onLineChange)="changeLine($event)"
  (onDetails)="openDetails($event)"
  (checkoutOrder)="checkoutOrder($event)"
  (onLineDelete)="deleteLine($event)"
  >
</app-checkout-page>
